<template>
    <div>
        <top :keyword="''" :tab="'news'"></top>
        <div class="all" style="width: 1233px !important;margin-right: auto;margin-left: auto;">
            <hr style="margin: 20px" />
            <div class="middle" style="height:700px;">
                <div v-for="a in articles" style="width: 50%;float: left;" :key="a.id">
                    <div class="column-inner">
                        <div class="policy-archive" style="position: relative;padding-left: 260px;">
                            <!-- <a :href="articleUrl(a)"> -->
                            <a :href="a.path" :target="a.state" :title="a.title">
                                <div class="image">
                                    <pic
                                        :src="a.coverImageUrl || '//cos.yzspeixun.com/resources/base/images/fail-image.png'"
                                    />
                                </div>
                                <div class="caption">
                                    <div class="headline">{{ a.title }}</div>
                                    <div class="abstract">{{ a.summary }}</div>
                                    <div class="time">
                                        <span>
                                            <i class="el-icon-time" />
                                            {{ formatDate(a.createDate) }}
                                        </span>
                                        <span>
                                            <i class="el-icon-view" />
                                            {{ a.viewCount }}
                                        </span>
                                    </div>
                                    <div class="time time2" v-if='a.sourceFrom'>
                                        <span>
                                            <i class="el-icon-link" />
                                            来源：{{ a.sourceFrom }}
                                        </span>
                                    </div>
                                    <span class="more">
                                        <i class="el-icon-arrow-right" />
                                    </span>
                                </div>
                                <!-- </a> -->
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from './top'
import bottom from './bottom'

export default {
    name: 'news',
    data() {
        return {
            articles: [],
            page: 1
        }
    },
    computed: {},
    methods: {
        list() {
            let qs = require('qs')
            let data = {
                pageSize: 10,
                pageNum: this.page,
                platformId: localStorage.getItem('datas'),
                code: 'news'
            }
            this.$http
                .post(this.$cmsPath + '/column/api/?' + qs.stringify(data))
                .then(result => {
                    result = result.data
                    if (result.success) {
                        this.articles = result.data.content
                        this.articles.map(item=>{
                            if(item.type == 1){
                                item.path = item.href
                                item.state = '_block'
                            }else{
                                item.path = '/policy/'+item.id
                            }
                        })
                    }
                })
        },
        next() {
            this.page += 1
        },
        prev() {
            this.page -= 1
        },
        articleUrl: function(article) {},
        formatDate: function(date) {
            date = new Date(date)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            if (month < 10) {
                month = '0' + month
            }
            if (day < 10) {
                day = '0' + day
            }
            return year + '-' + month + '-' + day
        }
    },
    created() {
        this.list()
    },
    components: {
        bottom: bottom,
        top: top
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';
.abstract {
    height: 26px !important;
    text-align: left;
}
.headline {
    text-align: left;
    height: 30px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.time2{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; 
}
.time {
    font-size: 20px;
    text-align: left;
}
.more {
    font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue